.errorContainer {
  display: flex;
  background-color: var(--bloom-colors-header-contrast-text-label);
  border-radius: 16px;
  padding: 16px;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 80px; /* Height of close button */
}

.errorText {
  color: var(--bloom-colors-header-contrast);
  font-size: 15px;
  line-height: 24px;
}

.errorIcon {
  svg {
    width: 24px;
  }

  path {
    fill: var(--bloom-colors-header-contrast);
  }
}
